import React from 'react';
import ImageIcon from './ImageIcon';

export default function PadLock() {
      return (
            <ImageIcon small src="/lock.png" />
      )
}